module.exports = __webpack_public_path__ + "assets/img/offside.webp?1d2ef82ece95503af2c9801175075649";